import { createComponent, EnvironmentInjector, Injectable } from '@angular/core';
import { NotificationMessageComponent } from './notification-message.component';
import { prepareNotificationForDisplay } from './notification-prepare';

/**
 * The message text a notification shows on the Notifications page, as plain text.
 *
 * Renders the page's own `NotificationMessageComponent` off-screen (never attached to the
 * document) and reads its text, so the toaster shows exactly what the page and the bell
 * slider show and the two can never drift apart. Returns '' when the page has no message
 * for the notification — callers use that to skip the toast.
 */
@Injectable({ providedIn: 'root' })
export class NotificationMessageTextService {
  constructor(private environmentInjector: EnvironmentInjector) {}

  textOf(notification: any): string {
    if (!notification) return '';
    // Same pre-processing the page and the slider apply (notification-mappers.ts), on a
    // copy so the caller's record is not mutated.
    const item = prepareNotificationForDisplay({
      ...notification,
      notifyData: notification.notifyData ? { ...notification.notifyData } : notification.notifyData,
    });

    const ref = createComponent(NotificationMessageComponent, { environmentInjector: this.environmentInjector });
    try {
      ref.setInput('item', item);
      ref.setInput('showActions', false);
      ref.changeDetectorRef.detectChanges();

      const host: HTMLElement = ref.location.nativeElement;
      // Slider-only hint ("Open notifications to respond.") is not part of the message.
      host.querySelectorAll('.ntf-msg-hint').forEach(el => el.remove());
      return (host.textContent || '').replace(/\s+/g, ' ').trim();
    } catch (e) {
      return '';
    } finally {
      ref.destroy();
    }
  }
}
